import { createContext, useContext, useEffect, useState } from 'react';
import { Client, client as braintreeClient } from 'braintree-web';
import { Loader } from '~/components/Loader/loader';
import { useThrowToErrorBoundary } from '~/components/ErrorBoundary';
import { useBraintreeToken } from '~/adapters/services/accounts/paymentMethods/hooks';
import { PWC } from '../typescript/propsWithChildren';

const Context = createContext<Client | null>(null);
export function useBraintreeClient() {
    const client = useContext(Context);
    if (!client) {
        throw new Error('Can not use braintree client outside braintree context');
    }

    return client;
}

export function BraintreeProvider({ children }: PWC) {
    const [client, setClient] = useState<Client | null>(null);
    const { data } = useBraintreeToken();
    const throwToErrorBoundary = useThrowToErrorBoundary();
    useEffect(() => {
        if (data) {
            (async () => {
                try {
                    const bclient = await braintreeClient.create({
                        authorization: data.clientToken,
                    });
                    setClient(bclient);
                } catch (e) {
                    throwToErrorBoundary(e);
                }
            })();
        }
        return () => {
            client?.teardown(() => undefined);
        };
    }, [data]);
    if (!client) {
        return <Loader title="Loading..." devLabel="Braintree provider" />;
    }

    return <Context.Provider value={client}>{children}</Context.Provider>;
}
